var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","goto":"https://forms.gle/mWtdihSBpLXJatSq9","icon":"help-box"}})}
var staticRenderFns = []

export { render, staticRenderFns }